import React from "react";
import { HelpPopoverButtonLink } from "@components/atoms/help-popover-button-link/help-popover-button-link";
import magnifyingGlassIcon from "@src/assets/svg/document-magnifying-glass.svg";
import { useI18N } from "@src/language/language-context";

interface FaqButtonTypes {
  url: string;
}

export const FaqButton = ({ url }: FaqButtonTypes) => {
  const i18n = useI18N();
  return (
    <HelpPopoverButtonLink
      icon={magnifyingGlassIcon}
      link={url}
      text={i18n("modules.helpButton.faqButtonText")}
      altText={i18n("modules.helpButton.faqButtonAltText")}
    />
  );
};
